import styled from 'styled-components';

import {
  BoxShadowConfig,
  Button,
  Col,
  RadiusConfig,
  Row,
  grey,
  neutral,
  neutralTrans,
} from 'enable-ui';

import { COLOR, COLOR_CONFIG } from 'constants/color';

export const DashboardWrapper = styled.div`
  .tab-line {
    padding: 0;
    div {
      background-color: #fd8a24;
    }
  }
  .jwbJTk {
    color: #fd8a24;
  }
`;

export const DashboardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
`;

export const Card = styled(Row)`
  border-radius: ${RadiusConfig.xs}px;
  margin-top: 6px;
  overflow: hidden;
  width: 100%;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  .active-title:hover {
    text-decoration: underline;
    cursor: pointer;
    color: #1b8bf1;
  }
  .active-title {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    line-height: 26px;
    max-height: 52px;
    width: 90%;
    font-size: 16px;
    line-height: calc(22 / 16);
    font-weight: 600;
  }
`;

export const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  height: 44px;
  border: 1px solid #00000040;
  border-radius: 12px;
  padding: 11px 20px;

  p {
    font-size: 18px;
    line-height: 26px;
    font-weight: 600;
  }

  .iiSZSL {
    height: 40px;
    background: transparent;
    width: auto;
    padding: 0;
    min-width: auto;
  }
`;

export const DropdownContent = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  background-color: ${COLOR_CONFIG.white};
  border: 1px solid ${neutralTrans['neutralTrans-15']};
  box-shadow: ${BoxShadowConfig['trans-6']};
  cursor: default;
  svg {
    width: 20px;
    height: 20px;
  }

  .es-input-master-wrapper {
    padding: 12px;
  }

  .text-input-wrapper {
    padding: 12px 16px 12px 8px;

    .text-input {
      padding: 0 8px;
    }
  }

  tbody {
    display: flex;
    flex-direction: column;
  }

  td:first-child {
    height: 20px;
    width: 20px;

    padding: 0 0 0 12px;
  }

  td:last-child {
    padding: 0;
  }

  tr {
    padding-bottom: 20px;
    background-color: ${COLOR_CONFIG.white};
  }
`;

export const AddContent = styled.div`
  display: flex;
  align-items: center;
  border-left: 1px solid ${neutralTrans['neutralTrans-25']};
  padding: 0 12px 0 20px;

  cursor: pointer;
  svg path {
    stroke: ${grey['grey-9']};
  }
`;

export const Options = styled.div`
  margin-top: 2px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 468px;
  overflow: auto;
`;

export const ItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  cursor: pointer;
  padding: 12px;

  &:hover {
    background-color: ${neutralTrans['neutralTrans-6']};
  }
`;

export const Item = styled(Row)`
  color: ${COLOR.surfaceNeutralBold['neutral-11']};
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 2px;
`;

export const FooterContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 24px 0px;
`;

export const DeleteComp = styled.div`
  display: flex;
  align-items: center;
  padding: 0px 12px 0px 10px;
  cursor: pointer;
  svg path {
    stroke: #ff4d4f;
  }
  p {
    color: #ff4d4f;
  }
`;

export const ButtonTransparent = styled.div`
  button {
    background: transparent;
    border: none;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  white-space: nowrap;
`;

export const TableHeader = styled.div`
  display: flex;
  top: 0;
  align-items: center;
  margin-top: 0;
  padding-top: 32px;
  border-bottom: 1px solid #f4f4f4;
  padding: 16px 28px 0 28px;
  background-color: ${COLOR_CONFIG['white-smoke']};
  border-radius: 12px;
`;

export const Body = styled.div<{ $justify?: string; $color?: string }>`
  display: flex;
  padding: 12px;
  width: 100%;
  align-items: center;
  justify-content: ${(props) => props.$justify || 'space-between'};
  background-color: ${(props) => props.$color || '#fff'};
  border: 1px solid ${(props) => props.$color || '#fff'};
  border-radius: 12px;
`;

export const CustomFileUpload = styled.div`
  max-width: 800px;

  .es-file-upload {
    background-color: transparent;
  }
  .es-upload-message {
    font-size: 16px;
    line-height: calc(22 / 16);
    color: ${COLOR_CONFIG['neutral-text']};
    font-weight: 400;
  }
`;

export const CustomInput = styled.div`
  .input-suffix {
    color: #808080;
  }
`;

export const CustomRadio = styled.div`
  .active-radio {
    background-color: #fd8a24;
  }
`;

export const LevelItem = styled.div`
  height: 56px;
  .selected {
    background: ${COLOR.linen};
    &:hover {
      background: ${COLOR.linen};
    }
  }
  &:hover {
    background: ${COLOR.neutral['neutral-4']} !important;
  }
`;

export const ButtonAddContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export const ButtonAdd = styled(Button)`
  gap: 6px;
  color: ${COLOR.purpel['purpel-6']} !important;
  font-weight: 600;
  border: 1px solid ${COLOR.purpel['purpel-6']};
  border-radius: 12px;
  margin: 24px 0 16px 0;

  path {
    stroke: ${COLOR.purpel['purpel-6']} !important;
  }
`;

export const ButtonEdit = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  color: ${COLOR.purpel['purpel-6']};
  font-weight: 600;
  cursor: pointer;

  path {
    stroke: ${COLOR.purpel['purpel-6']} !important;
  }
`;

export const CountInput = styled.input`
  height: 30px;
  width: 78px;
  border: 1px solid rgba(0, 0, 0, 0.25);
  border-radius: 12px;
  text-align: center;
  outline: none;

  &:focus {
    border: 1px solid ${COLOR.primary['primary-6']};
  }
`;

export const CancelButton = styled(Button)`
  background-color: ${COLOR_CONFIG.white};
  font-size: 16px;
  line-height: calc(22 / 16);
  font-weight: 600;
  padding: 11px 24px;
  height: 44px;
  border-radius: 12px;

  &:disabled {
    border: 1px solid ${COLOR.neutralTrans['neutralTrans-15']};
    color: ${COLOR.neutralTrans['neutralTrans-25']};
  }
`;

export const SubmitButton = styled(CancelButton)`
  background-color: ${COLOR.primary['primary-6']};
  border: none;

  &:disabled {
    background-color: ${COLOR.neutralTrans['neutralTrans-3']};
    color: ${COLOR.neutralTrans['neutralTrans-25']};
    border: 1px solid ${COLOR.neutralTrans['neutralTrans-3']};
  }

  &:hover {
    background-color: #b04b07;
  }
`;

export const DropdownBody = styled.div`
  margin-top: 2px;
`;
